import { configureStore as rtkConfigureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import rootReducer from '../reducers/rootReducer';
import { router } from '../Routes';

export function configureStore(initialState?: unknown) {
  const sagaMiddleware = createSagaMiddleware();
  sagaMiddleware.setContext({
    router,
  });

  const store = rtkConfigureStore({
    reducer: rootReducer,
    preloadedState: initialState,
    middleware: getDefault => getDefault().concat(sagaMiddleware),
    devTools: false,
  });

  return Object.assign(store, { runSaga: sagaMiddleware.run });
}

export default configureStore;
